// Z-index
export const Z_INDEX_MOBILE_NAVBAR = 1000;

export const Z_INDEX_OVERLAY = 200;

//Table
export const DEFAULT_TABLE_PAGE_SIZE = 10;
export const DEFAULT_TABLE_PAGE_NUM = 1;

//Modal
export const MODAL_WIDTH = {
  sm: 600,
  md: 800,
  lg: 900,
  xxl: 1200,
  xxxl: 1400,
};

//Text
export const TEXT_LINK_SIZE_CONFIG = {
  sm: { fontSize: 12, fontWeight: 400 },
  md: { fontSize: 14, fontWeight: 400 },
  lg: { fontSize: 16, fontWeight: 500 },
  xxl: { fontSize: 24, fontWeight: 800 },
};

export const TEXT_ELLIPSIS_LENGTH = 20;

export const CREATE_SERVICE_PREVIEW_WIDTH = '27.5rem';
export const CREATE_SERVICE_HEADER_HEIGHT = '4.5rem';

export const LAYOUT_SPACING = {
  FORM: {
    xs: 1.25,
    sm: 2,
    md: 2.5,
  },
  CARD: {
    xs: 1.25,
    sm: 2,
    md: 2.5,
    lg: 3.5,
  },
  BUTTON_GROUP: {
    xs: 1,
    sm: 1.5,
  },
};

export const OVERLAY_BACKGROUND_COLOR = 'rgba(0, 0, 0, 0.2)';
